import Vue from "vue"
import Router from "vue-router"
import App from "./App.vue"
import Login from "./components/Login.vue"
import UserView from "./components/UserView.vue"
import DashboardView from "./components/Dashboardview.vue"
import Dashboard from "./components/Dashboard.vue"
import DashboardDetails from "./components/DashboardDetails.vue"
import Teams from "./components/Teams.vue"
import TeamsView from "./components/TeamsView.vue"
import Stacks from "./components/Stacks.vue"
import StacksView from "./components/StacksView.vue"
import Profile from "./components/Profile.vue"
import Timeline from "./components/TimeLine.vue"
import TimelineView from "./components/TimeLineView.vue"
import TimelineDetails from "./components/TimeLineDetails.vue"
import Logout from "./components/Logout.vue"
Vue.use(Router)
const router =new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: App,
      children: [
                {
                  path: "login",
                  name: "login",
                  component: Login
                },
                {
                  path: '',
                  component: UserView,
                   children: [
                      { path: '', redirect: { path: "/dashboard" }, meta: {title: 'Timeline'}},
                      {
                        path: "logout",
                        name: "logout",
                        component: Logout
                      },
                      {
                        path: "dashboard",
                        component: DashboardView,
                        children: [
                                  { path: '', component: Dashboard, meta: {title: 'Dashboard' } },
                                  {
                                    path: "dashboardfulldetails",
                                    component: DashboardDetails,
                                    meta: {title: 'Stacks Usage Full Info'}
                                  }
                                 ]
                      },
                      {
                        path: "profile",
                        name: "profile",
                        component: Profile,
                        meta: {title: 'Profile'}
                      },
                      {
                        path: "stacks",
                        component: StacksView,
                        children: [
                                  { path: '', component: Stacks, meta: {title: 'Stacks' } },
                                  {
                                    path: "timeline",
                                    component: TimelineView,
                                     children: [
                                        { path: '', component: Timeline , meta: {title: 'Timeline'}},
                                        {
                                          path: "timelinefullinfo",
                                          component: TimelineDetails,
                                          meta: {title: 'Stacks Usage Full Info'}
                                        }
                                     ]
                                  }
                                 ]
                      },
                      {
                        path: "teams",
                        component: TeamsView,
                        children: [
                                  { path: '', component: Teams, meta: {title: 'Teams' } }
                                 ]
                      }
                   ]
                }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (router.app.$session.exists()) {
      if(to.name!="login" && to.path!="/" && to.name!="register"){
        next();
      }else{
        next({
        path: "/dashboard",
        replace: true
      });
      }
  } else {
    if(to.name=="login" || to.path=="/" || to.name=="register"){
      next();
    }else{
      next({
        path: "/login",
      name: "login"
      });
    }
  } 
  
});
export default router;